export default "__VITE_PUBLIC_ASSET__5b972d32__"